export default "__VITE_ASSET__BlB3fNX2__"